import { getAllDevices, getDeviceStatus, translateDeviceStatus, editDevice, delDeviceInfo } from './device-data';

export const WAIT_INIT_DEVICES = 'WAIT_INIT_DEVICES';
export const WAIT_QUERY_DEVICES = 'WAIT_QUERY_DEVICES';
export const INIT_DEVICES_SUCCESS = 'INIT_DEVICES_SUCCESS';
export const INIT_DEVICES_FAIL = 'INIT_DEVICES_FAIL';
export const GET_DEVICE_DETAIL = 'GET_DEVICE_DETAIL';
export const GET_DEVICE_DETAIL_SUCCESS = 'GET_DEVICE_DETAIL_SUCCESS';
export const GET_DEVICE_DETAIL_FAIL = 'GET_DEVICE_DETAIL_FAIL';
export const CLOSE_DEVICE_STATUS = 'CLOSE_DEVICE_STATUS';
export const DEL_DEVICE = 'DEL_DEVICE';
export const DEL_DEVICE_SUCCESS = 'DEL_DEVICE_SUCCESS';
export const DEL_DEVICE_FAIL = 'DEL_DEVICE_FAIL';
export const SAVE_DEVICE_DETAIL = 'SAVE_DEVICE_DETAIL';
export const SAVE_DEVICE_DETAIL_SUCCESS = 'SAVE_DEVICE_DETAIL_SUCCESS';
export const SAVE_DEVICE_DETAIL_FAIL = 'SAVE_DEVICE_DETAIL_FAIL';

export const forwardDashboard = () => (dispatch) => {
    dispatch({
        type: WAIT_INIT_DEVICES
    });
}

export const initDevicesData = (idToken) => (dispatch) => {
    let doGetAllDevice = new Promise((resolve, reject) => {
        getAllDevices(resolve, reject, idToken);
    });

    doGetAllDevice
    .then((data) => {
        let devices = data.devices;

        // get map online and offline devices size
        let monitorOnlineCount = 0;
        let monitorOfflineCount = 0;
        if (devices) {
            devices.forEach(element => {
                const location = element.location;
                if (location && location.lat && location.lng) {
                    if (element.isOnline === 1) {
                        monitorOnlineCount++;
                    } else {
                        monitorOfflineCount++;
                    }
                }
            });
        }

        dispatch({
            type: INIT_DEVICES_SUCCESS,
            params: {
                devices: devices,
                monitorOnline: monitorOnlineCount,
                monitorOffline: monitorOfflineCount
            }
        });
    })
    .catch((err) => {
        dispatch({
            type: INIT_DEVICES_FAIL,
            params: {
                errMsg: err.message
            }
        });
    });
};

export const queryDevices = () => (dispatch) => {
    dispatch({
        type: WAIT_QUERY_DEVICES
    });
}

export const queryDevicesSuccess = (data) => (dispatch) => {
    let devices = data.devices;
    dispatch({
        type: INIT_DEVICES_SUCCESS,
        params: {
            devices: devices
        }
    });
}

export const queryDevicesFail = (err) => (dispatch) => {
    dispatch({
        type: INIT_DEVICES_FAIL,
        params: {
            errMsg: err.message
        }
    });
}

export const getDeviceDetail = (idToken, detailSeq) => (dispatch) => {
    let doGet = new Promise((resolve, reject) => {
        getDeviceStatus(resolve, reject, idToken, detailSeq);
    });
    
    doGet
    .then((data) => {
        // set mac with detail seq
        data.thingName = detailSeq;

        // get translate Device Status 
        const deviceDetailInfo = translateDeviceStatus(data);        

        // id success keep detail params
        window.sessionStorage.setItem('RangeHood.' + window.CONFIG.CACHE_DEVICE, JSON.stringify({
            idToken: idToken, detailSeq: detailSeq
        }));

        dispatch({
            type: GET_DEVICE_DETAIL_SUCCESS,
            params: {
                deviceDetail: data,
                deviceDetailInfo: deviceDetailInfo
            }
        });
    })
    .catch((err) => {
        dispatch({
            type: GET_DEVICE_DETAIL_FAIL,
            params: {
                errMsg: err.message
            }
        });
    });

    // clear session detail data
    sessionStorage.removeItem('RangeHood.' + window.CONFIG.CACHE_DEVICE);

    dispatch({
        type: GET_DEVICE_DETAIL
    });
}


export const removeDevice = (idToken, detailSeq, devices) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        delDeviceInfo(resolve, reject, idToken, detailSeq);
    });

    doPost
    .then((data) => {
        const msg = data.message;
        if (msg === 'Success') {
            let newDevices = [];
            devices.forEach(device => {
                if (device.thingName !== detailSeq) {
                    newDevices.push(device);
                }
            });

            dispatch({
                type: DEL_DEVICE_SUCCESS,
                params: {
                    devices: newDevices
                }
            });
        } else {
            dispatch({
                type: DEL_DEVICE_FAIL,
                params: {
                    errMsg: msg
                }
            });
        }
    })
    .catch((err) => {
        dispatch({
            type: DEL_DEVICE_FAIL,
            params: {
                errMsg: err.message
            }
        });
    });

    dispatch({
        type: DEL_DEVICE
    });
}

export const closeDeviceStatus = () => (dispatch) => {
    dispatch({
        type: CLOSE_DEVICE_STATUS
    });
}

export const saveDeviceDetail = (idToken, bodyObj) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        editDevice(resolve, reject, idToken, bodyObj);
    });

    doPost
    .then((data) => {
        const msg = data.message;
        if (msg === 'Success') {
            dispatch({
                type: SAVE_DEVICE_DETAIL_SUCCESS
            });
        } else {
            dispatch({
                type: SAVE_DEVICE_DETAIL_FAIL,
                params: {
                    errMsg: data.message
                }
            });
        }
    })
    .catch((err) => {
        dispatch({
            type: SAVE_DEVICE_DETAIL_FAIL,
            params: {
                errMsg: err.message
            }
        });
    });

    dispatch({
        type: SAVE_DEVICE_DETAIL
    });
}